import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { axios } from 'lib/axios';

const toggleSupplierStar = ({ companyID, starred }) =>
  starred
    ? axios.post(`/api/companies/${companyID}/star`)
    : axios.delete(`/api/companies/${companyID}/star`);

export const useToggleSupplierStar = ({ onSuccess, onError } = {}) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: toggleSupplierStar,
    onSuccess: (_, variables) => {
      if (onSuccess) onSuccess(variables);
    },
    onError: (error, variables) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', { variant: 'error' });
      if (onError) onError(variables);
    },
  });
};
